import * as React from 'react';
import QuoteUpSvg from 'front/assets/other-icons/quote_up.svg';
import QuoteDownSvg from 'front/assets/other-icons/quote_down.svg';
import { quoteBorderClassName } from './lib/QuoteBorderStyles';
import type { QuoteBorderPropsType } from './types';

const QuoteBorder: React.FC<QuoteBorderPropsType> = ( props: QuoteBorderPropsType ) => {
    return (
        <div className={quoteBorderClassName}>
            <span />
            { !props.borderOnly && ( !props.closing ? <QuoteUpSvg /> : <QuoteDownSvg /> ) }
            <span />
        </div>
    );
};

export { QuoteBorder };
